import views from '@/views/';

export default [
  {
    component: views.outPatient.MedicalRecord,
    label: '门诊病历',
    path: 'outMedicalRecord',
    name: 'outMedicalRecord',
  },
  {
    component: views.outPatient.PatientList,
    label: '患者列表',
    path: 'patientList',
    name: 'patientList',
  },
  {
    component: views.outPatient.CaseHistory,
    label: '历史病历',
    path: 'caseHistory',
    name: 'caseHistory',
  },
  {
    component: views.outPatient.CaseDetail,
    label: '病历详情',
    path: 'caseDetail',
    name: 'caseDetail',
    menuHidden: true,
  },
  {
    component: views.member.memberDetail,
    label: '会员详情',
    path: 'memberDetail',
    name: 'memberDetail',
    menuHidden: true,
  },
  {
    component: views.member.newMember,
    label: '新建会员',
    path: 'newmember',
    name: 'newMember',
    menuHidden: true,
  },
];
